var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "data-table-vue": "" } }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.filterKey,
          expression: "filterKey"
        }
      ],
      attrs: { type: "text" },
      domProps: { value: _vm.filterKey },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.filterKey = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-responsive", attrs: { id: "table--search--data" } },
      [
        _c(
          "table",
          {
            staticClass:
              "table w-auto table-striped table-bordered table-responsive"
          },
          [
            _c("thead", [
              _c(
                "tr",
                _vm._l(_vm.columns, function(key) {
                  return _c(
                    "th",
                    {
                      class: { active: _vm.sortKey === key },
                      on: {
                        click: function($event) {
                          _vm.sortBy(key)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(key) +
                          "\n                    "
                      ),
                      _c("span", {
                        staticClass: "arrow",
                        class: _vm.sortOrders[key] > 0 ? "asc" : "dsc"
                      })
                    ]
                  )
                })
              )
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.filteredDataOrig, function(entry) {
                return _c(
                  "tr",
                  _vm._l(_vm.columns, function(key) {
                    return _c("td", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(entry[key]) +
                          "\n                "
                      )
                    ])
                  })
                )
              })
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4141098a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4141098a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./resources/assets/js/components/tables/table.vue
// module id = 521
// module chunks = 0